import React from "react";
import { SvgProps } from ".";

export const CaratUp: React.FC<SvgProps> = ({ height, width }) => (
  <svg
    width={width || "40px"}
    height={height || "40px"}
    viewBox="0 0 40 40"
    version="1.1"
  >
    <title id="Carat-Up">Carat-Up</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Carat-Up">
        <rect id="Rectangle" x="0" y="0" width="40" height="40" />
        <polyline
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(20.000000, 19.000000) rotate(-180.000000) translate(-20.000000, -19.000000) "
          points="31 13 20 25 9 13"
        />
      </g>
    </g>
  </svg>
);

export default {};
